<template>
    <div class="page-waiting">
        正在登录中，请稍后
    </div>
</template>

<script type="text/ecmascript-6">

    import axios from 'axios';
    import vue from 'vue';
    vue.prototype.$axios = axios;
    import qs from 'qs';
    vue.prototype.qs = qs;
    import VueCookies from 'vue-cookies'
    vue.use(VueCookies);
    import utilApi from '@/api/util'
    export default {

        components: {
        },
        data () {
            return {
                openid:"",
                type:'',
                username:'',
                password:'',
                rurl:'',
                code:"",
                wbt:{}
            }
        },
        mounted() {
            // this.checkUser();
            this.getToken();
            // console.log(this.code)
            this.rurl= this.$cookies.get("formUrl");
        },
        methods:{
            getToken(){
                let _this = this
                this.code=this.$route.query.code;
                if(this.$route.query.code==undefined){
                    if(_this.$cookies.get("formUrl")!=null&&_this.$cookies.get("formUrl")!=undefined&&_this.$cookies.get("formUrl")!=""){
                        window.location.href =_this.$cookies.get("formUrl")
                    }else{
                        window.location.href ="http://www.renrendonghua.com";
                    }

                }


                utilApi.weiboToken(this.code).then( res=>{
                    console.log("res================",res)
                    _this.wbt = res.response
                    if(_this.wbt.access_token){
                        _this.openid=res.response.access_token
                        _this.checkUser();
                    }else {
                        _this.$message({
                            message: "绑定失败，请重新尝试",
                            type: 'error'
                        });
                    }
                })
                // let url="/oauth2/access_token";
                // let data={
                //     client_id:"2471057307",
                //     client_secret:"2cf8723d3b8d85f5a51253cc88a09ceb",
                //     grant_type:"authorization_code",
                //     code:this.code,
                //     redirect_uri:"http://www.renrendonghua.com/auth/authWeiBo",
                // }
                // console.log("url==============>",url+qs.stringify(data));
                // _this.$axios.post(url,qs.stringify(data)).then(function (result) {
                //     if(result.status==200){
                //         _this.openid=result.data.uid
                //         _this.checkUser();
                //     }
                //
                // })
            },
            checkUser(){
                let _this=this;
                let userId=this.$cookies.get("user_id")
                let  url="/api/auth/checkUser?openid="+this.openid+"&type=1&te="+new Date().getMilliseconds();
                _this.$axios.get(url).then(function (result) {
                    if(result.data.code!=1){
                        _this.$message({
                            message: result.data.message,
                            type: 'warning'
                        });
                    }
                    console.log(result)
                    if(result.data.response.isBinded==1){
                        _this.username=result.data.response.username;
                        _this.password=result.data.response.password ;
                        _this.doLogin();
                    }else if(result.data.response.isBinded==2){
                        _this.$message({
                            message: "此微博已被其他账号绑定",
                            type: 'warning'
                        });
                        _this.$router.push("/setting")
                    }else{
                        console.log("localStorage.formUrl2",localStorage.getItem("formUrl"))
                        _this.$router.push("/login/weibo/auth/info?openid="+_this.openid)
                    }
                })
            },
            doLogin(){
                let _this=this;
                let url='/api/auth/autoLogin?tet'+new Date().getMilliseconds();
                let postData = {
                    'type':1,
                    'username':this.username,
                    'password':this.password,
                    'rurl':this.rurl,
                }
                this.$axios.post(url, qs.stringify(postData)).then(function(result){
                    if(result.status==200){
                        console.log(result.data.response)
                        let message='';
                        let postData2={
                            'username':result.data.response.username,
                            'password':result.data.response.password
                        }
                        _this.$cookies.remove("user_id", "/", process.env.VUE_APP_DOMAIN);
                        _this.$cookies.remove("user_name", "/", process.env.VUE_APP_DOMAIN);
                        _this.$cookies.remove("sso_sessionid", "/", process.env.VUE_APP_DOMAIN);
                        //用户信息保存成功，根据返回信息自动登录
                        let fast_login_url='http://cas.21teacher.com/restLoginCheck?time='+new Date().getMilliseconds();

                        _this.$axios.post(fast_login_url, qs.stringify(postData2)).then(function(result2){

                            console.log(result2.data)
                            if(result2.data.code=="10"){
                                localStorage.removeItem('captchaCheck')
                                let sso_sessionid =result2.data.token;
                                let user_id=result2.data.userModel.id;
                                let user_name=result2.data.userModel.userName;
                                console.log(sso_sessionid)
                                let checkurl='/api/checkLogin?sso_sessionid='+sso_sessionid+'&time='+ new Date().getMilliseconds();
                                _this.$axios.get(checkurl).then(function(result2){
                                    if(result2.data.isLogin&&result2.data.casFastUserModel!=null){
                                        _this.$cookies.set("userId",user_id,0,"/",'.renrendonghua.com');
                                        _this.$cookies.set("user_id",user_id,0,"/",process.env.VUE_APP_DOMAIN);
                                        _this.$cookies.set("user_name",user_name,0,"/",process.env.VUE_APP_DOMAIN);
                                        let updateLoginUrl="/rrbi/updateLoginUserInfo"
                                        _this.$axios.get(updateLoginUrl).then(function () {
                                            if (message==4||message==5){
                                                let noticUrl="/rrbi/notifications/saveRegisterNotify?userId="+result2.data.casFastUserModel.id+"&userName="+result2.data.casFastUserModel.name+"&objectType="+message
                                                _this.$axios.get(noticUrl).then(function () {
                                                    if(_this.$cookies.get("formUrl")!=null&&_this.$cookies.get("formUrl")!=undefined&&_this.$cookies.get("formUrl")!=""){
                                                        window.location.href =_this.$cookies.get("formUrl")
                                                    }else{
                                                        if(_this.rurl!=""){
                                                            window.location.href = _this.rurl;
                                                        }else{
                                                            window.location.href ="http://www.renrendonghua.com";
                                                        }
                                                    }

                                                })
                                            }else{
                                                if(_this.$cookies.get("formUrl")!=null&&_this.$cookies.get("formUrl")!=undefined&&_this.$cookies.get("formUrl")!=""){
                                                    window.location.href =_this.$cookies.get("formUrl")
                                                }else{
                                                    if(_this.rurl!=""){
                                                        window.location.href = _this.rurl;
                                                    }else{
                                                        window.location.href ="http://www.renrendonghua.com";
                                                    }
                                                }

                                            }
                                        })


                                    }else{
                                        _this.$message({
                                            message: '登录失败',
                                            type: 'warning'
                                        });
                                        _this.loading=false;
                                    }
                                })
                            }else{
                                _this.$message({
                                    message: '手机短信验证失败，请重新尝试',
                                    type: 'warning'
                                });
                                _this.loading=false;
                            }

                        })
                    }
                })
            }
        }
    }

</script>


<style scoped lang="less">
    .page-waiting{
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: @NAVHEIGHT;
        height: 50vh;
    }
</style>
